import { render, staticRenderFns } from "./PaginatedItemsWrapper.vue?vue&type=template&id=1e866cd8&scoped=true&lang=pug&"
import script from "./PaginatedItemsWrapper.vue?vue&type=script&lang=js&"
export * from "./PaginatedItemsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PaginatedItemsWrapper.vue?vue&type=style&index=0&id=1e866cd8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e866cd8",
  null
  
)

/* custom blocks */
import block0 from "./PaginatedItemsWrapper.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports